module.exports = __webpack_public_path__ + "img/bcd.51a879fa.svg";